export const services = [
  {
    id: "documentary",
    icon: "Film",
    image: "/services/documentary.png",
    title: { en: "Documentary Filmmaking", ar: "الأفلام الوثائقية" },
    tagline: {
      en: "Real people. Real stakes. Cinematic truth.",
      ar: "شخصيات حقيقية، حكايات صادقة، حقيقة سينمائية.",
    },
    desc: {
      en: "We treat documentary as long-form journalism at cinema quality — deeply researched, patiently observed, and edited with narrative rigor.",
      ar: "نتعامل مع الوثائقي كصحافة بصرية طويلة بجودة سينمائية — بحث معمّق، ملاحظة صبورة، ومونتاج بمنهج سردي محكم.",
    },
    process: [
      { en: "Research & scripting", ar: "البحث وكتابة السيناريو" },
      { en: "Field production", ar: "التصوير الميداني" },
      { en: "Editing & sound design", ar: "المونتاج وتصميم الصوت" },
      { en: "Grade & distribution", ar: "التصحيح اللوني والتوزيع" },
    ],
    deliverables: { en: "Feature docs · short-form · branded documentaries · series", ar: "أفلام طويلة · أعمال قصيرة · وثائقيات علامة · مسلسلات" },
  },
  {
    id: "commercial",
    icon: "Camera",
    image: "/services/commercial.png",
    title: { en: "Commercial Advertising", ar: "الإعلان التجاري" },
    tagline: {
      en: "Brand stories with a cinematographer's eye.",
      ar: "قصص علامات بعين مدير تصوير.",
    },
    desc: {
      en: "From TV anthem films to platform-native launches, we produce commercial work that respects the brand and the audience's intelligence.",
      ar: "من إعلانات الأناشيد التلفزيونية إلى إطلاقات المنصات الرقمية — نُنتج أعمالاً تجارية تحترم العلامة وذكاء الجمهور.",
    },
    process: [
      { en: "Concept & storyboard", ar: "الفكرة واللوحة القصصية" },
      { en: "Pre-production & casting", ar: "التحضير والاختيار" },
      { en: "Directed production", ar: "الإخراج والتنفيذ" },
      { en: "Post-production & finishing", ar: "المعالجة والإنهاء" },
    ],
    deliverables: { en: "TVCs · anthem films · social edits · brand integration", ar: "إعلانات تلفزيونية · أناشيد · نسخ اجتماعية · تكامل مع العلامة" },
  },
  {
    id: "drama",
    icon: "Clapperboard",
    image: "/services/drama.jpg",
    title: { en: "Drama & Cinematic Production", ar: "الدراما والإنتاج السينمائي" },
    tagline: { en: "Short films, series, and cinematic scenes.", ar: "أفلام قصيرة، مسلسلات، ومَشاهد سينمائية." },
    desc: {
      en: "Original narrative work developed in-house or in collaboration with writers and studios across the region.",
      ar: "أعمال سردية أصلية تُطوَّر داخلياً أو بالتعاون مع كتّاب ومنتجين في المنطقة.",
    },
    process: [
      { en: "Development & script", ar: "التطوير والسيناريو" },
      { en: "Cast & creative direction", ar: "التمثيل والإدارة الإبداعية" },
      { en: "Principal photography", ar: "التصوير الرئيسي" },
      { en: "Post & festival strategy", ar: "المعالجة واستراتيجية المهرجانات" },
    ],
    deliverables: { en: "Shorts · limited series · pilot episodes · cinematic scenes", ar: "أفلام قصيرة · مسلسلات محدودة · حلقات تجريبية · مَشاهد سينمائية" },
  },
  {
    id: "motion-3d",
    icon: "Boxes",
    image: "/services/motion-3d.png",
    title: { en: "Motion Graphics & 3D Design", ar: "الموشن جرافيك و ٣د" },
    tagline: { en: "Ideas rendered in light, geometry, and time.", ar: "أفكار مصنوعة من الضوء والهندسة والزمن." },
    desc: {
      en: "Product visualisation, architectural walkthroughs, character animation, and motion-first ads — engineered for scale and clarity.",
      ar: "تصوّر منتجات، جولات معمارية، تحريك شخصيات، وإعلانات موشن — مصنوعة للانتشار والوضوح.",
    },
    process: [
      { en: "Concept & design language", ar: "الفكرة ولغة التصميم" },
      { en: "Modeling & look development", ar: "النمذجة وتطوير المظهر" },
      { en: "Animation & FX", ar: "التحريك والمؤثرات" },
      { en: "Compositing & delivery", ar: "التركيب والتسليم" },
    ],
    deliverables: { en: "Motion ads · product 3D · arch. animation · character work", ar: "إعلانات موشن · ٣د للمنتجات · تحريك معماري · شخصيات" },
  },
  {
    id: "product-photography",
    icon: "Aperture",
    image: "/services/product-photography.jpg",
    title: { en: "Product Photography", ar: "تصوير المنتجات" },
    tagline: { en: "Products, staged like film.", ar: "منتجاتك كأنها لقطة سينمائية." },
    desc: {
      en: "High-end product photography for brands, e-commerce and campaigns — lit, styled and retouched to feel like cinema stills.",
      ar: "تصوير احترافي للمنتجات للعلامات والمتاجر الإلكترونية والحملات — بإضاءة وتنسيق وريتوش يجعل كل صورة تبدو كلقطة سينمائية.",
    },
    process: [
      { en: "Brief & moodboard", ar: "الملخّص واللوحة المزاجية" },
      { en: "Studio lighting & styling", ar: "الإضاءة والتنسيق في الاستوديو" },
      { en: "Shoot & art direction", ar: "التصوير والإدارة الفنية" },
      { en: "Retouch & delivery", ar: "الريتوش والتسليم" },
    ],
    deliverables: { en: "Hero stills · e-commerce sets · campaign visuals · packaging shots", ar: "لقطات رئيسية · مجموعات للمتاجر · بصريات حملات · صور تغليف" },
  },
  {
    id: "talent-discovery",
    icon: "Star",
    image: "/services/talent-discovery.png",
    title: { en: "Talent Discovery", ar: "اكتشاف المواهب" },
    tagline: { en: "New faces. New voices. New stars.", ar: "وجوه جديدة. أصوات جديدة. نجوم جدد." },
    desc: {
      en: "A dedicated pipeline for discovering, casting and developing new on-screen and on-mic talent across Saudi Arabia and the Arab region.",
      ar: "مسار متخصّص لاكتشاف المواهب الجديدة أمام الكاميرا والميكروفون واختيارها وتطويرها في المملكة العربية السعودية والمنطقة العربية.",
    },
    process: [
      { en: "Open call & sourcing", ar: "الاستقبال المفتوح والبحث" },
      { en: "Casting & camera tests", ar: "الاختبار وتجارب الكاميرا" },
      { en: "Coaching & development", ar: "التدريب والتطوير" },
      { en: "Placement in productions", ar: "الترشيح في الإنتاجات" },
    ],
    deliverables: { en: "Casting reels · talent profiles · on-set placement · development pipeline", ar: "ريلات اختبار · ملفات مواهب · ترشيح في الإنتاج · برنامج تطوير" },
  },
  {
    id: "sound-recording",
    icon: "Mic",
    image: "/services/sound-recording.jpg",
    title: { en: "Professional Sound Recording", ar: "التسجيل الصوتي باحترافيه" },
    tagline: { en: "Voice, tuned like cinema.", ar: "صوت مضبوط كما السينما." },
    desc: {
      en: "Studio-grade voice-over, ADR, foley and sound-design capture — treated, mixed and mastered inside our sound-treated room.",
      ar: "تسجيل صوتي احترافي: أصوات، ADR، فولي وتصميم صوت — بمعالجة ومكس وماستر داخل غرفة صوت معزولة.",
    },
    process: [
      { en: "Session prep & script", ar: "التحضير والسكربت" },
      { en: "Direction & recording", ar: "التوجيه والتسجيل" },
      { en: "Edit & noise treatment", ar: "المونتاج ومعالجة الضجيج" },
      { en: "Mix & master", ar: "المكس والماستر" },
    ],
    deliverables: { en: "Voice-over · ADR · foley · podcast · audiobook · brand sonic identity", ar: "تعليق صوتي · ADR · فولي · بودكاست · كتب صوتية · هوية صوتية للعلامات" },
  },
  {
    id: "drone-photography",
    icon: "Plane",
    image: "/services/drone.jpg",
    title: { en: "Drone Photography", ar: "تصوير الدرون" },
    tagline: {
      en: "Cinematic perspectives from the sky.",
      ar: "منظور سينمائي من السماء.",
    },
    desc: {
      en: "Licensed drone operators capturing high-resolution aerial cinematography — sweeping establishing shots, dynamic reveals and precise architectural passes.",
      ar: "مشغّلو درون مرخّصون يلتقطون تصويراً جوياً سينمائياً عالي الدقة — لقطات تأسيسية واسعة، وكشوف حركية، ومرورات هندسية دقيقة على المباني.",
    },
    process: [
      { en: "Flight planning & permits", ar: "تخطيط الرحلة والتصاريح" },
      { en: "Location scouting & risk check", ar: "استكشاف الموقع وفحص المخاطر" },
      { en: "Aerial cinematography", ar: "التصوير الجوي السينمائي" },
      { en: "Stabilisation & color", ar: "التثبيت والتصحيح اللوني" },
    ],
    deliverables: { en: "Aerial reels · establishing shots · real-estate flyovers · event coverage", ar: "ريلات جوية · لقطات تأسيسية · جولات عقارية · تغطية فعاليات" },
  },
  {
    id: "advertising",
    icon: "Megaphone",
    image: "/services/advertising.jpg",
    title: { en: "Advertising & Promotion", ar: "دعاية وإعلان" },
    tagline: {
      en: "Concepts that sell, crafted with cinema DNA.",
      ar: "أفكار تبيع، بروح سينمائية.",
    },
    desc: {
      en: "Full-funnel advertising campaigns — from strategic concept and copy to art direction, production and platform-native delivery for TV, social and digital-out-of-home.",
      ar: "حملات إعلانية متكاملة — من الفكرة الاستراتيجية والنصوص، إلى الإدارة الفنية والإنتاج والتسليم المهيّأ لكل منصة: تلفزيون، سوشيال، ولوحات رقمية خارجية.",
    },
    process: [
      { en: "Brief & strategy", ar: "الملخّص والاستراتيجية" },
      { en: "Concept & creative copy", ar: "الفكرة والنصوص الإبداعية" },
      { en: "Production & art direction", ar: "الإنتاج والإدارة الفنية" },
      { en: "Media adaptation & rollout", ar: "التكييف الإعلامي والإطلاق" },
    ],
    deliverables: { en: "Full campaigns · TVCs · social ads · OOH keyvisuals · brand launches", ar: "حملات كاملة · إعلانات تلفزيونية · إعلانات سوشيال · لوحات خارجية · إطلاقات علامات" },
  },
];
